/**
 * Floating section list for the On track bucket. Rows are multi-select.
 *
 * Deliberately NO "All On track" row, unlike the sibling buckets: the parent is a residual rather than
 * the union of its sections, so its total sits below them when sections overlap and above them when an
 * RMA matches no section. An "All" row would show a number that neither equals the sum below it nor
 * matches what selecting it returns. The card row still shows the parent total.
 */
import { observer } from "mobx-react";
import "./rma-list-on-track-popup.scss";
import { RmaListBucketFiltersStore } from "../../../../../../../../../rma-list-page/stores/rma-list-bucket-filters-store";
import RmaListOnTrackPopupRow from "./components/rma-list-on-track-popup-row/rma-list-on-track-popup-row";

interface IProps {
    bucketFiltersStore: RmaListBucketFiltersStore;
    getLabel: (value: string) => string;
    onToggle: (value: string) => void;
}

const RmaListOnTrackPopup: React.FC<IProps> = observer(({ bucketFiltersStore, getLabel, onToggle }) => {
    const selected = bucketFiltersStore.selectedOnTrack;

    return (
        <div className="rma-list-on-track-popup">
            {bucketFiltersStore.onTrackOptions.map((option) => (
                <RmaListOnTrackPopupRow
                    key={option.value}
                    label={getLabel(option.value)}
                    count={option.count}
                    isSelected={selected.includes(option.value)}
                    onToggle={() => onToggle(option.value)}
                />
            ))}
        </div>
    );
});

export default RmaListOnTrackPopup;
